import { forwardRef, type Ref, type SVGProps } from "react";
const IconShovelFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M21.5 14.161a3 3 0 0 1 1.573.45 2.88 2.88 0 0 1 1.427 2.456v5.817a4.95 4.95 0 0 1-2.108 3.821L18.22 29.4a4.4 4.4 0 0 1-4.438 0L9.61 26.705a4.95 4.95 0 0 1-2.11-3.821v-5.815a2.88 2.88 0 0 1 1.425-2.457 3 3 0 0 1 1.574-.45zm-6.338 9.553c0 .353.346.64.772.64s.773-.287.773-.64v-7.602h-1.545zM16.101 2c1.726.006 3.139 1.168 3.2 2.633l-.925 8.225H13.83l-.927-8.225C12.967 3.17 14.377 2.008 16.101 2m-.15 2.279a.6.6 0 0 0-.61.592c0 .327.273.593.61.593a.6.6 0 0 0 .612-.593.6.6 0 0 0-.611-.592"
    />
  </svg>
);
const ForwardRef = forwardRef(IconShovelFilledSVG);
ForwardRef.displayName = "IconShovelFilled";
export { ForwardRef as IconShovelFilled };
